import React from 'react';
import Link from 'next/link';
import Styles from './styles.js';
const StaysLocation = props => {
  const data = props;
  return (
    <>
      {/* <!-- Heading Row--> */}
      {data.bg == 'black' ? (
        <div className="w-full pt-3 px-0" style={{ backgroundColor: '#161616' }}>
          <div className="lg:container mx-auto pt-5 lg:pt-3 px-6 lg:px-0 xl:px-0  2xl:px-4 pb-6  ">
            <div className="grid lg:grid-cols-2 grid-cols-1 px-2 lg:px-3 lg:gap-x-12 lg:pt-5 md:pb-5 lg:pb-2 xl:pb-5">
              <div className=" md:mt-1  lg:pl-4 ">
                <img loading="lazy" className=" img img-fluid w-full " src={data.img} alt="..." />
              </div>
              <div className=" pt-4 md:pt-5 lg:pt-0 lg:ps-4">
                <h1
                  className={
                    data.spacing
                      ? 'text-[48px] font-normal xl:pl-1 color xl:pt-4 xl:mt-1 pt-4 lg:pt-2'
                      : 'text-[48px] font-normal  lg:pl-1 color xl:pt-4 xl:mt-1 pt-4'
                  }
                  style={{ fontFamily: 'Fjalla One', color: '#F7F7F7' }}>
                  {data.title}
                </h1>
                {data.location}
                <p
                  className={
                    data.spacing
                      ? '  responsiveText mt-4 lg:mt-2 xl:mt-4 xl:pt-1 mb-2 lg:mb-1 xl:pb-2 xl:pl-1  '
                      : '  responsiveText mt-4 pt-xl-1 pb-2 pe-xl-1  '
                  }
                  style={{ fontFamily: 'Josefin Sans', color: '#A4A4A4' }}>
                  {data.description}{' '}
                </p>

                {data.href ? (
                  <Link href={data.href}>
                    <button
                      type="button"
                      className={
                        data.spacing
                          ? 'btn btn-stays font-semibold  rounded-0 mt-4 lg:mt-2 xl:mt-3'
                          : 'btn btn-stays font-semibold text-[18px] leading-[27px] rounded-0 mt-3'
                      }
                      style={{
                        fontFamily: 'Josefin Sans',
                        color: '#010101',
                        backgroundColor: '#FCBD00',
                        padding: '12px 28px',
                      }}>
                      {data.btnTitle}
                    </button>
                  </Link>
                ) : (
                  <a href={data.hrefExt} target="_blank" rel="noreferrer">
                    <button
                      type="button"
                      className="btn btn-stays font-semibold fs-16-18 rounded-0 mt-3"
                      style={{
                        fontFamily: 'Josefin Sans',
                        color: '#010101',
                        backgroundColor: '#FCBD00',
                        padding: '12px 28px',
                      }}>
                      {data.btnTitle}
                    </button>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="lg:container mx-auto px-6 pt-5 mt-4 lg:pt-3 lg:px-0 xl:px-0 xxl:px-4 pb-4 bg-white">
          <div className="grid lg:grid-cols-2 grid-cols-1 gx-0 px-2 px-lg-3 lg:pt-5 md:pb-5 gap-x-12">
            <div className=" md:mt-1  lg:pl-4 ">
              <img loading="lazy" className=" img img-fluid w-full " src={data.img} alt="..." />
            </div>
            <div className="  lg:pt-0 lg:ps-4 pt-5 ">
              <h1
                className="text-[48px] leading-[60px] font-normal lg:pr-1 color xl:pt-4 xl:mt-1 pt-4"
                style={{ fontFamily: 'Fjalla One' }}>
                {data.title}
              </h1>
              {data.location}

              {data.description}
              {data.descriptionTwo && data.descriptionTwo}

              {data.href ? (
                <Link href={data.href}>
                  <button
                    type="button"
                    className="btn font-semibold btn-stays text-[18px] leading-[27px] rounded-0 mt-2 md:mt-3"
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      padding: '14px 30px',
                    }}>
                    {data.btnTitle}
                  </button>
                </Link>
              ) : (
                <a href={data.hrefExt} target="_blank" rel="noreferrer">
                  <button
                    type="button"
                    className="btn font-semibold fs-16-18  w-auto   rounded-0 mt-2 md:mt-3"
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      padding: '14px 30px',
                    }}>
                    {data.btnTitle}
                  </button>
                </a>
              )}
            </div>
          </div>
        </div>
      )}
      <Styles />
    </>
  );
};

export default StaysLocation;
